import { ThemeTypings } from "@chakra-ui/react";

export const MOBILE_BREAKPOINT_SIZE = "lg";

export const mobileStyleBreakpoint = <T = string | number>(
  mobileValue: T,
  desktopValue: T,
  breakpoint: ThemeTypings["breakpoints"] = MOBILE_BREAKPOINT_SIZE
): Record<string, T> => ({
  base: mobileValue,
  [breakpoint]: desktopValue,
});

export const desktopOnly = mobileStyleBreakpoint<boolean>(false, true);
export const mobileOnly = mobileStyleBreakpoint<boolean>(true, false);

export const detailsBodyPadding = mobileStyleBreakpoint(4, 6);

export const inputSize = mobileStyleBreakpoint<string>("sm", "md");
